export const noop = (): void => {
    // Do nothing
};

export const noopPromise = <T>(): Promise<T> => Promise.reject(new Error());
